import { gql } from '@apollo/client';
import { useQuery } from '@tbitop/api';
import { useGraphQLErrorHandler } from '@tbitop/error-handling';
import { usePagination } from '../../core/application/pagination';
import type { ObjektFilterInput, Sortierrichtung } from './__generated__/globalTypes';
import type { NeueObjekteFuerKampagneQuery, NeueObjekteFuerKampagneQueryVariables } from './__generated__/NeueObjekteFuerKampagneQuery';


export const useNeueObjekteFuerKampagnen = (kampagne: string, filter: ObjektFilterInput, sortierrichtung: Sortierrichtung, skip?: boolean) => {
  const { handleWithErrorNotification } = useGraphQLErrorHandler();
  const { paginationVariables, fetchNextPage } = usePagination();

  const { data, loading, error, fetchMore, refetch } = useQuery<NeueObjekteFuerKampagneQuery, NeueObjekteFuerKampagneQueryVariables>(gql`
    query neueObjekteFuerKampagne($kampagne: String!, $anzahlProSeite: Int!, $seite: Int!, $filter: ObjektFilterInput, $sortierrichtung: Sortierrichtung!) {
      neueObjekteFuerKampagne(kampagne: $kampagne, seite: $seite, anzahlProSeite: $anzahlProSeite, filter: $filter, sortierrichtung: $sortierrichtung) {
        aktuelleSeite {
          ...Objekt
        }
        beschreibung {
          hatNachfolger,
          gesamtAnzahl,
        }
      }
    }
    fragment Objekt on Objekt {
      id
      name
      name2
      nummer
      adresse {
        ort
        postleitzahl
        strasse
      }
    }
  `, {
    onError: handleWithErrorNotification('Die Liste der Objekte für neue Kampagnen konnte nicht geladen werden.'),
    variables: {
      filter,
      kampagne,
      sortierrichtung: sortierrichtung,
      ...paginationVariables,
    },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    skip: skip,
  });

  return {
    data: data?.neueObjekteFuerKampagne?.aktuelleSeite ?? [],
    loading,
    refetch,
    error,
    total: data?.neueObjekteFuerKampagne?.beschreibung?.gesamtAnzahl,
    pagination: {
      fetchMore: () => fetchNextPage<NeueObjekteFuerKampagneQuery>(fetchMore)
        .catch(handleWithErrorNotification('Das Laden weiterer Objekte ist fehlgeschlagen.')),
      hasMore: data?.neueObjekteFuerKampagne?.beschreibung?.hatNachfolger ?? false,
    },
  };
};
